export default {
  common: {
    ctaStartTrial: 'ابدأ الآن',
    ctaBookDemo: 'احجز عرضاً',
    noCreditCard: 'ابدأ في دقائق. خطط من 100 دولار شهرياً لـ10 سائقين.',
    faqTitle: 'الأسئلة الشائعة',
    breadcrumb: {
      home: 'الرئيسية',
      resources: 'الموارد',
      features: 'الميزات',
      blog: 'المدونة',
      caseStudies: 'دراسات الحالة',
    },
  },
  nav: {
    builtFor: 'حسب القطاع',
    features: 'الميزات',
    resources: 'الموارد',
    howItWorks: 'كيف يعمل',
    pricing: 'الأسعار',
    partners: 'الشركاء',
    integrations: 'التكاملات',
    contact: 'اتصل بنا',
    login: 'تسجيل الدخول',
    getStarted: 'ابدأ الآن',
    mobileLanguage: 'اللغة',
    comingSoon: 'قريباً',
    panels: {
      builtFor: {
        title: 'حلول حسب القطاع',
        subtitle: 'إدارة أسطول مصممة لاحتياجات قطاعك.',
        viewAll: 'عرض كل القطاعات',
        useCases: 'القطاعات',
        useCasesSub: 'مجمّعة حسب المجال — اختر أو اعرض الكل.',
        groupFoodHealth: 'الأغذية والصحة والبقالة',
        groupRetailCommerce: 'التجزئة والتجارة الإلكترونية والتوزيع',
        groupLogisticsField: 'اللوجستيات والعمليات الميدانية',
        industryBenefitsTitle: 'فوائد حسب القطاع',
        industryBenefitsSub: 'نتائج مثبتة عبر القطاعات',
        quickAccessTitle: 'وصول سريع',
        successStory: 'قصة نجاح',
        successStoryTitle: 'كيف تخفض المؤسسات تكاليف التوصيل بنسبة 20–30%',
        successStoryDesc: 'اكتشف كيف تستخدم شركات لوجستية رائدة Geofleet لتحسين العمليات.',
        readCaseStudy: 'قراءة دراسة الحالة',
        readyToOptimize: 'مستعد لتحسين عمليات قطاعك؟',
        getIndustryDemo: 'طلب عرض لقطاعك',
      },
      features: {
        title: 'ميزات المنصة',
        subtitle: 'أدوات مدعومة بالذكاء الاصطناعي للتوصيل والمسارات وإثبات التوصيل وعمليات الأسطول.',
        viewAll: 'عرض كل الميزات',
        trackingDelivery: 'التتبع والتوصيل',
        trackingDeliverySub: 'أدوات للعملاء والسائقين',
        operationsInsights: 'العمليات والرؤى',
        operationsInsightsSub: 'أتمتة ومالية وتحليلات',
        aiFirst: 'الذكاء الاصطناعي أولاً',
        everyFeaturePowered: 'كل ميزة مدعومة بالذكاء الاصطناعي',
        automatingDecisions: 'أتمتة القرارات والتنبؤ بالنتائج والتعلم من بياناتك.',
        startFreeTrial: 'ابدأ الآن',
        getDemo: 'احجز عرضاً',
        readyToAutomate: 'مستعد لأتمتة عمليات التوصيل؟',
      },
      resources: {
        title: 'الموارد',
        subtitle: 'قصص نجاح ودلائل ودعم.',
        viewAll: 'عرض كل الموارد',
        learning: 'التعلم',
        successStories: 'قصص النجاح',
        support: 'الدعم',
        latestReport: 'دليل',
        lastMile2026: 'كيف يعمل Geofleet',
        lastMileDesc: 'ست خطوات من الطلب إلى إثبات التسليم.',
        readReport: 'اقرأ الدليل',
        needHelp: 'تحتاج مساعدة للبدء؟',
        contactExperts: 'اتصل بخبرائنا',
      },
    },
    items: {
      builtFor: {
        restaurants: { label: 'المطاعم وQSR', description: 'توصيل أسرع وخدمة أفضل' },
        pharmacies: { label: 'الصيدليات', description: 'توصيل وصفات موثوق' },
        retail: { label: 'التجزئة', description: 'تبسيط توصيلات التجزئة' },
        ecommerce: { label: 'التجارة الإلكترونية', description: 'توسيع متجرك الإلكتروني' },
        couriers: { label: 'المراسلة واللوجستيات', description: 'إدارة السائقين والمسارات' },
        laundry: { label: 'غسيل وكوي', description: 'استلام وتوصيل' },
        flowers: { label: 'ورود وهدايا', description: 'توصيلات حساسة للوقت' },
        water: { label: 'توصيل المياه', description: 'إدارة مسارات متكررة' },
        fuel: { label: 'الوقود والغاز', description: 'لوجستيات وقود عند الطلب' },
        manufacturing: { label: 'التصنيع', description: 'آخر ميل في سلسلة التوريد' },
        grocery: { label: 'البقالة والمتاجر', description: 'فترات زمنية، كثافة مسارات، بدائل' },
        'b2b-distribution': { label: 'B2B والجملة', description: 'برنامج توصيل التوزيع' },
        'medical-supplies': { label: 'طبي ومختبرات', description: 'عينات، أطقم، نوافذ زمنية' },
        'field-service': { label: 'خدمة ميدانية', description: 'مواعيد، قطع، شاحنات' },
        'building-supplies': { label: 'بناء وحمولات ضخمة', description: 'أثقال، نوافذ، إثبات تسليم' },
        'automotive-parts': { label: 'قطع غيار سيارات', description: 'نفس اليوم وشبكات الوكلاء' },
        'contract-logistics': { label: 'لوجستيات تعاقدية و3PL', description: 'اتفاقيات خدمة وبوابات متعددة' },
      },
      features: {
        brandedTracking: { label: 'رابط تتبع بالعلامة', description: 'صفحات تتبع مخصصة للعملاء' },
        routePlanner: { label: 'مخطط المسارات', description: 'توجيه متعدد المحطات محسّن بالذكاء الاصطناعي' },
        aiAgents: { label: 'وكلاء الذكاء الاصطناعي', description: 'أتمتة الإرسال والعمليات' },
        proofOfDelivery: { label: 'إثبات التوصيل', description: 'صور وتوقيعات وطوابع زمنية' },
        autoAllocation: { label: 'التخصيص التلقائي', description: 'وكلاء ذكاء اصطناعي يسندون الطلبات إلى السائقين' },
        cashManagement: { label: 'إدارة النقد', description: 'تتبع مدفوعات الدفع عند الاستلام' },
        reportsAnalytics: { label: 'التقارير والتحليلات', description: 'رؤى أداء مدعومة بالذكاء الاصطناعي' },
        driverApp: { label: 'تطبيق السائق', description: 'تتبع فوري وأدوات للسائقين' },
      },
      resources: {
        caseStudies: { label: 'دراسات الحالة', description: 'قصص نجاح العملاء' },
        blog: { label: 'المدونة', description: 'اتجاهات ونصائح حسب القطاع' },
        roiCalculator: {
          label: 'حاسبة العائد على الاستثمار',
          description: 'قدّر التوفير من تقليل التأخير وتحسين استخدام الأسطول',
        },
        whitepapers: { label: 'الورقات البيضاء', description: 'أبحاث وأدلة معمقة' },
        blogArticles: { label: 'المدونة والمقالات', description: 'اتجاهات وأفضل الممارسات' },
        webinars: { label: 'الندوات والفعاليات', description: 'جلسات مباشرة وتسجيلات' },
        customerSuccess: { label: 'نجاح العميل', description: 'كيف تحقق الشركات العائد على الاستثمار' },
        helpCenter: { label: 'مركز المساعدة' },
        apiDocs: { label: 'توثيق API' },
      },
      industryBenefits: {
        fasterDeliveries: { value: '30%', label: 'توصيلات أسرع', description: 'المسارات المحسّنة تقلل الأوقات.' },
        costReduction: { value: '20–30%', label: 'تقليل التكاليف', description: 'وقود وتكاليف تشغيل أقل.' },
      },
      quickAccess: {
        helpCenter: 'مركز المساعدة',
        contactSupport: 'اتصل بالدعم',
      },
    },
  },
};
